// React
import { useState, useEffect } from "react";
import { useFormik } from "formik";
//PrimeReact
import { InputMask } from "primereact/inputmask";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";

import { pesquisarAll } from '../../../service/Orgao'

//Seplag
import CardSeplag from "../../../components/CardSeplag";
import ModalSeplag from "../../../components/ModalSeplag";
import TableSeplag from "../../../components/TableSeplag";
import RotuloSeplag from "../../../components/RotuloSeplag";

import Timeline from '../components/Timeline'


//Service
import {
  consultaManterObrigacao,
  buscaGenerica,
  pesquisaAll as listaObrigacaoAll
} from "../../../service/manterObrigacao";

import { Checkbox } from "primereact/checkbox";

// import ObrigacaoLoader from "./ObrigacaoLoader";
import { useSelector } from "react-redux";
import { buscarLogPorObrigacao } from "../../../service/Audit/Obrigacao";
import CustomizedContent from "./components/CustomizedContent";

const camposTabela = [
  { nome: "nomePessoa", titulo: "Nome" },
  { nome: "numCpfFormatado", titulo: "CPF" },
  { nome: "amparoLegal.descAmparoLegal", titulo: "Amparo Legal" },
  { nome: "dataInclusao", titulo: "Data do Amparo" },
  { nome: "descOrgao", titulo: "Orgão" },
  { nome: "descSituacao", titulo: "Situação" },
];

const Index = () => {
  const count = useSelector((state) => state.counterRequestReducer.counterRequest);
  const isLoading = count > 0;

  const [listaObrigacoes, setListaObrigacoes] = useState([]);
  const [logs, setLogs] = useState([]);
  const [obrigacaoSelected, setObrigacaoSelected] = useState();
  const [visible, setVisible] = useState(false);
  const [optionsOrgaoDeOrigemDaObrigacao, setOptionsOrgaoDeOrigemDaObrigacao] = useState([])

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: consultaManterObrigacao,
    validate: (data) => {
      let errors = {};
      return errors;
    },
    onSubmit: async (dados) => {
      let FLAG_QUITADO_FOLHA_ARCH = dados.flagQuitadoFolhaArh !== true ? FLAG_QUITADO_FOLHA_ARCH === "N" : FLAG_QUITADO_FOLHA_ARCH === "S";
      let NUMERO_CERTIDAO = dados.checkCertidoesNaoEmitidas ? "0000000000" : String(dados.numrCertidao) === "null" ? null : dados.numrCertidao.toString();

      let payload = {
        pessoa: dados.pessoa,
        cpf: dados.numrCpf ? dados.numrCpf.replace(/[^\w\s]|_/g, "") : dados.numrCpf,
        numrMatricula: dados.numrMatricula,
        numrCertidao: NUMERO_CERTIDAO,
        dataQuitacao: dados.dataQuitacao === undefined || dados.dataQuitacao === false ? (dados.dataQuitacao = null) : dados.dataQuitacao,
        dataCompensCert: dados.dataCompensCert === undefined || dados.dataCompensCert === false ? (dados.dataCompensCert = null) : dados.dataCompensCert,
        dataAutenticCert: dados.dataAutenticCert === undefined || dados.dataAutenticCert === false ? (dados.dataAutenticCert = null) : dados.dataAutenticCert,
        dataEmissaoCert: dados.dataEmissaoCert === undefined || dados.dataEmissaoCert === false ? (dados.dataEmissaoCert = null) : dados.dataEmissaoCert,
        flagQuitadoFolhaArh: FLAG_QUITADO_FOLHA_ARCH,
      };

      await buscaGenerica(payload).then((res) => {
        let dados = res.content;
        setListaObrigacoes(
          dados.map(function (element) {
            let novoElement = {
              ...element,
              numCpfFormatado: element.numrCpf ? element.numrCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4") : "",
              dataQuitacao: element.dataQuitacao ? element.dataQuitacao : "",
              dataCancelamento: element.dataCancelamento ? element.dataCancelamento : "",
              codgValidadorObrigacao: element.codgValidadorObrigacao ? element.codgValidadorObrigacao : "",
              descSituacao: element.descSituacao ? element.descSituacao : "",
              flagSituacao: element.flagSituacao ? element.flagSituacao : "",
              listaAmparoLegalObrigacao: element.listaAmparoLegalObrigacao.map(function (element2) {
                return { ...element2.amparoLegal };
              }),
            };
            if (element.amparoLegal) {
              novoElement.listaAmparoLegalObrigacao.push(element.amparoLegal);
            }

            return novoElement;
          })
        );
      });
    },
  });

  useEffect(() => {
    listaObrigacaoAll().then((res) => {
      let dados = res.content;
      setListaObrigacoes(
        dados.map(function (element) {
          let novoElement = {
            ...element,
            numCpfFormatado: element.numrCpf ? element.numrCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4") : "",
            dataQuitacao: element.dataQuitacao ? element.dataQuitacao : "",
            dataCancelamento: element.dataCancelamento ? element.dataCancelamento : "",
            codgValidadorObrigacao: element.codgValidadorObrigacao ? element.codgValidadorObrigacao : "",
            descSituacao: element.descSituacao ? element.descSituacao : "",
            flagSituacao: element.flagSituacao ? element.flagSituacao : "",
            listaAmparoLegalObrigacao: element.listaAmparoLegalObrigacao.map(function (element2) {
              return { ...element2.amparoLegal };
            }),
          };
          if (element.amparoLegal) {
            novoElement.listaAmparoLegalObrigacao.push(element.amparoLegal);
          }
          return novoElement;
        })
      );
    });

    pesquisarAll().then(res => {
      setOptionsOrgaoDeOrigemDaObrigacao(res)
    })
  }, []);

  const showModalLog = (rowData) => {
    setObrigacaoSelected({ ...rowData });
    buscarLogPorObrigacao(rowData.idenObrigacao).then((res) => {

      setLogs(res.filter((element) => element.auditoriaDTO));;
      setVisible(true);
    });
  };

  const botoesAcoes = (rowData) => {
    return <Button icon="pi pi-list" tooltip="log" tooltipOptions={{ position: "left" }} onClick={() => showModalLog(rowData)} />;
  };

  const content = (item) => {

    if (!item.pessoa) {
      item = {
        ...item,
        pessoa: {
          nomePessoa: ""
        }
      }
    }

    if (!item.tipoCertidao) {
      item = {
        ...item,
        tipoCertidao: {
          nomeTipoCertida: ""
        }
      }
    }

    if (!item.orgao) {
      item = {
        ...item,
        orgao: {}
      }
    }
    return <CustomizedContent optionsOrgaoDeOrigemDaObrigacao={optionsOrgaoDeOrigemDaObrigacao} item={item} />
  }
  return (
    <CardSeplag title="Obrigação">
      {/* {isLoading && <ObrigacaoLoader />} */}

      {!isLoading && (
        <form className="p-col-12" onSubmit={formik.handleSubmit}>
          <div className="p-grid p-col-12">
            <div className="p-col-12 p-md-12 p-lg-6 p-grid" style={{ margin: 0 }}>
              <Checkbox inputId="dataQuitacao" name="dataQuitacao" value={formik.values.dataQuitacao} onChange={formik.handleChange} checked={formik.values.dataQuitacao} className="p-col-2 p-md-1 p-lg-1" />
              <RotuloSeplag nome="Quitadas" cols="10 3" />

              <Checkbox inputId="dataCompensCert" name="dataCompensCert" value={formik.values.dataCompensCert} onChange={formik.handleChange} checked={formik.values.dataCompensCert} className="p-col-2 p-md-1 p-lg-1" />
              <RotuloSeplag nome="Em Compensação" cols="10 3" />

              <Checkbox inputId="dataAutenticCert" name="dataAutenticCert" value={formik.values.dataAutenticCert} onChange={formik.handleChange} checked={formik.values.dataAutenticCert} className="p-col-2 p-md-1 p-lg-1" />
              <RotuloSeplag nome="Autenticadas" cols="10 3" />
            </div>

            <div className="p-col-12 p-md-12 p-lg-6 p-grid" style={{ margin: 0 }}>
              <Checkbox inputId="dataEmissaoCert" name="dataEmissaoCert" value={formik.values.dataEmissaoCert} onChange={formik.handleChange} checked={formik.values.dataEmissaoCert} className="p-col-2 p-md-1 p-lg-1" />
              <RotuloSeplag nome="Emitidas" cols="10 3" />

              <Checkbox inputId="checkCertidoesNaoEmitidas" name="checkCertidoesNaoEmitidas" onChange={formik.handleChange} checked={formik.values.checkCertidoesNaoEmitidas} className="p-col-2 p-md-1 p-lg-1" />
              <RotuloSeplag nome="Não Emitidas (Só Obrigação)" cols="10 3" />
            </div>

            <div className="p-col-12" />

            <RotuloSeplag nome="Nome" cols="12 6 3">
              <InputText name="pessoa" id="pessoa" onChange={formik.handleChange} value={formik.values.pessoa} style={{ width: "100%" }} />
            </RotuloSeplag>

            <RotuloSeplag nome="CPF" cols="12 6 3">
              <InputMask name="numrCpf" id="numrCpf" mask="999.999.999-99" style={{ width: "100%" }} onChange={formik.handleChange} value={formik.values.numrCpf} />
            </RotuloSeplag>

            <RotuloSeplag nome="Número da Matrícula" cols="12 6 3">
              <InputText name="numrMatricula" id="numrMatricula" onChange={formik.handleChange} value={formik.values.numrMatricula} style={{ width: "100%" }} />
            </RotuloSeplag>

            <RotuloSeplag nome="Número da Certidão" cols="12 6 3">
              <InputText name="numrCertidao" id="numrCertidao" disabled={formik.values.checkCertidoesNaoEmitidas ? true : false} onChange={formik.handleChange} value={formik.values.numrCertidao} style={{ width: "100%" }} />
            </RotuloSeplag>

            <div className="p-col-12 p-md-2" style={{ marginTop: "10px" }}>
              <Button icon="pi pi-search" label="Pesquisar" className="p-col" />
            </div>
          </div>
        </form>
      )}

      <TableSeplag
        hasEventoAcao
        camposTabela={camposTabela}
        dados={listaObrigacoes}
        botoesAcoes={botoesAcoes}
      />

      {visible && (
        <ModalSeplag
          type="NONE"
          titulo={`Log da Obrigação `}
          visible={visible}
          fechar={() => setVisible(false)}
          maximizable
        >

          <Timeline
            logs={logs}
            customizedContent={content}
          />

        </ModalSeplag>
      )}

    </CardSeplag>
  );
};

export default Index;
